import { useEffect } from "react";
import { useServiceOptionsBase } from "../../service-dropdown/utils/use-service-options-base.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const useServicesMultiChoiceOptions = (props) => {
  const {
    isLoading,
    options,
    isEmpty,
    shouldRender,
    setOptions,
    setIsEmpty,
    setHasInitialDataLoaded
  } = useServiceOptionsBase({
    fieldType: FIELD_TYPES.SERVICES_MULTI_CHOICE,
    isEditor: props.isEditor
  });
  const hasFullServiceData = props.options?.every(
    (option) => option.label && option.id
  );
  useEffect(() => {
    if (hasFullServiceData && props.options) {
      setOptions(props.options);
      setIsEmpty(props.options.length === 0);
      setHasInitialDataLoaded(true);
      return;
    }
  }, [
    hasFullServiceData,
    props.options,
    setOptions,
    setIsEmpty,
    setHasInitialDataLoaded
  ]);
  return { isLoading, options, isEmpty, shouldRender };
};
export {
  useServicesMultiChoiceOptions
};
//# sourceMappingURL=use-services-multi-choice-options.js.map
